var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199.648,
    height: 190.833,
    viewBox: "0 0 199.648 190.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7140",
    "data-name": "Group 7140",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4223",
    "data-name": "Path 4223",
    d: "M1501.55,323.008l-11.225-21.086H1555.4L1585.262,358h-24.669q-3.214,5.355-6.427,10.711A165.514,165.514,0,0,0,1541.242,358h-.214c-.017-.018-.031-.038-.048-.057-2.225-2.33-4.934-3.812-7.61-5.539-3.125-2.017-6.032-4.353-9.154-6.375-4.5-2.916-9.334-6.216-14.8-6.666-4.411-1.959-8.583-3.6-12.376-4.928l5.617-9.362Z",
    transform: "translate(-1392.78 -248.643)",
    fill: "#93ddff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2499",
    "data-name": "Rectangle 2499",
    width: 23.908,
    height: 18.644,
    transform: "translate(42.013 80.745)",
    fill: "#93ddff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    width: 23.908,
    height: 64.551,
    transform: "translate(42.013 125.356)",
    fill: "#93ddff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2805",
    "data-name": "Group 2805",
    transform: "translate(64.517 53.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4224",
    "data-name": "Path 4224",
    d: "M1455.8,314.519l-3.461-3.345-5.46,2.774-3.833-8.615-4.795,6.546-1.492-1.094,6.679-9.119,4.338,9.751,4.9-2.489,4.409,4.261Z",
    transform: "translate(-1436.758 -301.666)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2816",
    "data-name": "Group 2816",
    transform: "translate(140.628 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2806",
    "data-name": "Group 2806",
    transform: "translate(13.31 12.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4225",
    "data-name": "Path 4225",
    d: "M1605.322,275.871h-10.394v-1.85h10.394a2.4,2.4,0,0,0,2.4-2.4v-4.092a5.985,5.985,0,0,1,1.876-4.288,15.272,15.272,0,0,0-11.312-26.184,15.428,15.428,0,0,0-14.611,14.189,15.27,15.27,0,0,0,4.571,11.994,5.983,5.983,0,0,1,1.876,4.288v2.243h-1.85v-2.243a4.153,4.153,0,0,0-1.318-2.965,17.112,17.112,0,0,1-5.124-13.445,17.3,17.3,0,0,1,16.381-15.91,17.117,17.117,0,0,1,12.679,29.355,4.153,4.153,0,0,0-1.318,2.965v4.092A4.252,4.252,0,0,1,1605.322,275.871Z",
    transform: "translate(-1581.786 -235.196)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2807",
    "data-name": "Group 2807",
    transform: "translate(20.395 27.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4226",
    "data-name": "Path 4226",
    d: "M1602.145,268.284h-4.434a4.434,4.434,0,1,1,4.434-4.434Zm-4.434-7.019a2.584,2.584,0,0,0,0,5.169h2.584V263.85A2.587,2.587,0,0,0,1597.711,261.266Z",
    transform: "translate(-1593.277 -259.416)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2808",
    "data-name": "Group 2808",
    transform: "translate(27.413 35.015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2501",
    "data-name": "Rectangle 2501",
    width: 1.85,
    height: 11.259,
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2809",
    "data-name": "Group 2809",
    transform: "translate(31.624 27.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4227",
    "data-name": "Path 4227",
    d: "M1615.922,268.284h-4.434V263.85a4.434,4.434,0,1,1,4.434,4.434Zm-2.584-1.85h2.584a2.584,2.584,0,1,0-2.584-2.585Z",
    transform: "translate(-1611.488 -259.416)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2810",
    "data-name": "Group 2810",
    transform: "translate(31.623 35.015)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2502",
    "data-name": "Rectangle 2502",
    width: 1.85,
    height: 11.259,
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2811",
    "data-name": "Group 2811",
    transform: "translate(28.338 56.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4228",
    "data-name": "Path 4228",
    d: "M1609.645,314.332l-.437-1.8a3.958,3.958,0,0,0,3.027-3.858v-.054h-6.076v-1.85h7.925v1.9A5.8,5.8,0,0,1,1609.645,314.332Z",
    transform: "translate(-1606.159 -306.773)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2812",
    "data-name": "Group 2812",
    transform: "translate(38.492 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 5.741,
    height: 1.849,
    transform: "translate(0 5.376) rotate(-69.453)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2813",
    "data-name": "Group 2813",
    transform: "translate(16.377 0.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 1.85,
    height: 5.741,
    transform: "translate(0 0.765) rotate(-24.447)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2814",
    "data-name": "Group 2814",
    transform: "translate(0 17.938)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2505",
    "data-name": "Rectangle 2505",
    width: 1.849,
    height: 5.741,
    transform: "translate(0 1.732) rotate(-69.442)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2815",
    "data-name": "Group 2815",
    transform: "translate(53.028 15.982)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2506",
    "data-name": "Rectangle 2506",
    width: 5.742,
    height: 1.85,
    transform: "translate(0 2.378) rotate(-24.462)",
    fill: "#93ddff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "gear-5-icon",
    transform: "translate(82.571 0.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4229",
    "data-name": "Path 4229",
    d: "M1475.263,256.658l-4.592-4.192,2.1-5.009a17.147,17.147,0,0,1-1.229-2.624l-5.2-1.585-.31-6.866,5.031-2.05a17,17,0,0,1,.982-2.727l-2.551-4.794,4.634-5.078,5.005,2.109a17.163,17.163,0,0,1,2.624-1.228l1.585-5.2,6.864-.313,2.052,5.032a17.171,17.171,0,0,1,2.724.984l4.8-2.55,5.074,4.631-2.107,5.007a17.073,17.073,0,0,1,1.229,2.624l5.2,1.586.313,6.864-5.03,2.053a17.321,17.321,0,0,1-.983,2.726l2.552,4.795-4.195,4.594-1.366-1.247,3.314-3.63L1501.4,246.1l.209-.425a15.521,15.521,0,0,0,1.167-3.236l.111-.461,4.692-1.915-.194-4.258-4.848-1.48-.152-.45a15.288,15.288,0,0,0-1.458-3.112l-.249-.405,1.966-4.671-3.146-2.871-4.475,2.379-.425-.211a15.347,15.347,0,0,0-3.232-1.168l-.462-.11-1.915-4.695-4.255.194-1.479,4.851-.451.152a15.346,15.346,0,0,0-3.114,1.456l-.4.249-4.67-1.967-2.874,3.148,2.381,4.474-.211.425a15.144,15.144,0,0,0-1.165,3.231l-.11.464-4.7,1.914.193,4.258,4.849,1.479.152.451a15.32,15.32,0,0,0,1.456,3.113l.248.4-1.962,4.674,3.628,3.312Zm12.491-9.318a8.52,8.52,0,1,1,.4-.009Q1487.952,247.34,1487.754,247.34Zm.018-15.162c-.1,0-.207,0-.309.007a6.624,6.624,0,1,0,.309-.007Z",
    transform: "translate(-1466.039 -217.104)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2817",
    "data-name": "Group 2817",
    transform: "translate(186.243 60.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4230",
    "data-name": "Path 4230",
    d: "M1645.7,326.145l-11.52-6.256,10.92-5.727Zm-7.592-6.227,5.579,3.03-.291-5.8Z",
    transform: "translate(-1634.18 -314.162)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2818",
    "data-name": "Group 2818",
    transform: "translate(34.698 0.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4231",
    "data-name": "Path 4231",
    d: "M1392.5,224.12a4.1,4.1,0,1,1,4.1-4.1A4.109,4.109,0,0,1,1392.5,224.12Zm0-6.359a2.255,2.255,0,1,0,2.255,2.255A2.257,2.257,0,0,0,1392.5,217.761Z",
    transform: "translate(-1388.397 -215.911)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2836",
    "data-name": "Group 2836",
    transform: "translate(0 74.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2819",
    "data-name": "Group 2819",
    transform: "translate(0 16.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4232",
    "data-name": "Path 4232",
    d: "M1351.68,462.012l-19.558-3.9,18.783-95.422,19.558,3.9Zm-17.387-5.356,15.93,3.179,18.07-91.793-15.929-3.179Z",
    transform: "translate(-1332.122 -362.685)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2820",
    "data-name": "Group 2820",
    transform: "translate(93.734 23.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4233",
    "data-name": "Path 4233",
    d: "M1505.269,462.176h-1.85V377.056h-17.424v75.819h-1.85V375.206h21.124Z",
    transform: "translate(-1484.145 -375.206)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2821",
    "data-name": "Group 2821",
    transform: "translate(141.833 40.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2507",
    "data-name": "Rectangle 2507",
    width: 1.85,
    height: 70.531,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2822",
    "data-name": "Group 2822",
    transform: "translate(36.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4234",
    "data-name": "Path 4234",
    d: "M1421.635,452.758h-30.4V336.565h30.4Zm-28.548-1.85h26.7V338.415h-26.7Z",
    transform: "translate(-1391.237 -336.565)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2823",
    "data-name": "Group 2823",
    transform: "translate(64.996 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4235",
    "data-name": "Path 4235",
    d: "M1439.386,451.833h-1.85V336.565h30.4v18.827h-1.85V338.415h-26.7Z",
    transform: "translate(-1437.537 -336.565)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2824",
    "data-name": "Group 2824",
    transform: "translate(37.374 23.825)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2508",
    "data-name": "Rectangle 2508",
    width: 27.229,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2825",
    "data-name": "Group 2825",
    transform: "translate(37.374 44.643)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2509",
    "data-name": "Rectangle 2509",
    width: 27.229,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2826",
    "data-name": "Group 2826",
    transform: "translate(73.806 15.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4236",
    "data-name": "Path 4236",
    d: "M1458.214,375.234a6.389,6.389,0,1,1,6.389-6.39A6.4,6.4,0,0,1,1458.214,375.234Zm0-10.929a4.54,4.54,0,1,0,4.539,4.539A4.544,4.544,0,0,0,1458.214,364.3Z",
    transform: "translate(-1451.825 -362.455)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2827",
    "data-name": "Group 2827",
    transform: "translate(73.806 92.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4237",
    "data-name": "Path 4237",
    d: "M1458.214,498.682a6.389,6.389,0,1,1,6.389-6.389A6.4,6.4,0,0,1,1458.214,498.682Zm0-10.929a4.54,4.54,0,1,0,4.539,4.54A4.545,4.545,0,0,0,1458.214,487.753Z",
    transform: "translate(-1451.825 -485.903)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2828",
    "data-name": "Group 2828",
    transform: "translate(119.522 52.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4238",
    "data-name": "Path 4238",
    d: "M1534.793,443.535c-4.865,0-8.824-4.83-8.824-10.766S1529.927,422,1534.793,422s8.823,4.829,8.823,10.766S1539.658,443.535,1534.793,443.535Zm0-19.682c-3.846,0-6.974,4-6.974,8.916s3.128,8.916,6.974,8.916,6.973-4,6.973-8.916S1538.638,423.853,1534.793,423.853Z",
    transform: "translate(-1525.969 -422.003)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2829",
    "data-name": "Group 2829",
    transform: "translate(114.957 44.643)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2510",
    "data-name": "Rectangle 2510",
    width: 26.933,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2830",
    "data-name": "Group 2830",
    transform: "translate(114.957 78.845)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 26.933,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2831",
    "data-name": "Group 2831",
    transform: "translate(79.271 36.758)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2512",
    "data-name": "Rectangle 2512",
    width: 1.85,
    height: 44.308,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2832",
    "data-name": "Group 2832",
    transform: "translate(45.316 56.524)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2513",
    "data-name": "Rectangle 2513",
    width: 12.291,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2833",
    "data-name": "Group 2833",
    transform: "translate(45.316 64.196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2514",
    "data-name": "Rectangle 2514",
    width: 12.291,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2834",
    "data-name": "Group 2834",
    transform: "translate(15.324 42.934)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2515",
    "data-name": "Rectangle 2515",
    width: 1.849,
    height: 15.247,
    transform: "translate(0 1.815) rotate(-78.87)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2835",
    "data-name": "Group 2835",
    transform: "translate(10.771 60.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2516",
    "data-name": "Rectangle 2516",
    width: 1.849,
    height: 15.247,
    transform: "translate(0 1.815) rotate(-78.873)",
    fill: "#033662"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2837",
    "data-name": "Group 2837",
    transform: "translate(71.839 188.983)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2517",
    "data-name": "Rectangle 2517",
    width: 95.007,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2840",
    "data-name": "Group 2840",
    transform: "translate(89.88 47.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2838",
    "data-name": "Group 2838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4239",
    "data-name": "Path 4239",
    d: "M1582.037,354.332H1568v-1.85h10.958l-30.811-57.846h-67.171l11.777,22.11-1.633.869-13.225-24.829h71.362Z",
    transform: "translate(-1477.894 -292.786)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2839",
    "data-name": "Group 2839",
    transform: "translate(7.308 10.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4240",
    "data-name": "Path 4240",
    d: "M1552.148,372.659l-.836-.769a174.673,174.673,0,0,0-60.493-36.295l-1.072-.376,12.9-21.5c2.55-4.249,2.55-4.249,3.074-4.249l.094,0a84.292,84.292,0,0,1,61.335,36.668l.482.71ZM1492.5,334.227a176.5,176.5,0,0,1,59.227,35.537l13.71-22.849a82.443,82.443,0,0,0-59.227-35.537C1504.395,314.4,1494.952,330.141,1492.5,334.227Z",
    transform: "translate(-1489.747 -309.471)",
    fill: "#033662"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2842",
    "data-name": "Group 2842",
    transform: "translate(164.547 164.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2841",
    "data-name": "Group 2841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4241",
    "data-name": "Path 4241",
    d: "M1598.993,497.681V482.667h1.85v11.917l7.5-4.036,8.02,4.318V482.16h1.85v14.9h-1.682l-8.188-4.408Z",
    transform: "translate(-1598.993 -482.16)",
    fill: "#93ddff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2858",
    "data-name": "Group 2858",
    transform: "translate(1.162 15.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2843",
    "data-name": "Group 2843",
    transform: "translate(6.577 2.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4242",
    "data-name": "Path 4242",
    d: "M1346.524,307.073h-1.85V244.911h48.107v1.85h-46.257Z",
    transform: "translate(-1344.674 -244.911)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2844",
    "data-name": "Group 2844",
    transform: "translate(14.422 15.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4243",
    "data-name": "Path 4243",
    d: "M1386.42,270.885a4.634,4.634,0,0,1-3.565-1.764,2.685,2.685,0,0,0-4.483,0,4.482,4.482,0,0,1-7.128,0,2.683,2.683,0,0,0-4.481,0,4.481,4.481,0,0,1-7.127,0,2.861,2.861,0,0,0-2.24-1.207v-1.85a4.632,4.632,0,0,1,3.563,1.764,2.682,2.682,0,0,0,4.48,0,4.482,4.482,0,0,1,7.127,0,2.684,2.684,0,0,0,4.481,0,4.483,4.483,0,0,1,7.129,0,2.688,2.688,0,0,0,4.486,0,4.633,4.633,0,0,1,3.565-1.764v1.85a2.869,2.869,0,0,0-2.243,1.207A4.633,4.633,0,0,1,1386.42,270.885Z",
    transform: "translate(-1357.397 -266.065)",
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2845",
    "data-name": "Group 2845",
    transform: "translate(14.422 38.254)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2518",
    "data-name": "Rectangle 2518",
    width: 14.507,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2846",
    "data-name": "Group 2846",
    transform: "translate(14.422 28.747)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2519",
    "data-name": "Rectangle 2519",
    width: 14.507,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2847",
    "data-name": "Group 2847",
    transform: "translate(14.422 47.139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2520",
    "data-name": "Rectangle 2520",
    width: 23.218,
    height: 1.85,
    fill: "#033662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2848",
    "data-name": "Group 2848",
    transform: "translate(0 9.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4244",
    "data-name": "Path 4244",
    d: "M1338.112,264.292a4.1,4.1,0,1,1,0-8.209v1.85a2.255,2.255,0,0,0,0,4.51Z",
    transform: "translate(-1334.007 -256.083)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2849",
    "data-name": "Group 2849",
    transform: "translate(0 33.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4245",
    "data-name": "Path 4245",
    d: "M1338.112,304.126a4.1,4.1,0,1,1,0-8.209v1.85a2.255,2.255,0,0,0,0,4.51Z",
    transform: "translate(-1334.007 -295.917)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2850",
    "data-name": "Group 2850",
    transform: "translate(0 46.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    "data-name": "Path 4246",
    d: "M1338.112,325.223a4.1,4.1,0,1,1,0-8.208v1.85a2.255,2.255,0,1,0,0,4.509Z",
    transform: "translate(-1334.007 -317.014)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2851",
    "data-name": "Group 2851",
    transform: "translate(0 21.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4247",
    "data-name": "Path 4247",
    d: "M1338.112,283.9a4.1,4.1,0,1,1,0-8.209v1.85a2.255,2.255,0,1,0,0,4.509Z",
    transform: "translate(-1334.007 -275.688)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2857",
    "data-name": "Group 2857",
    transform: "translate(40.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2852",
    "data-name": "Group 2852",
    transform: "translate(0.88 8.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    "data-name": "Path 4248",
    d: "M1403.2,293.97a1.5,1.5,0,0,1-.607-.129,1.478,1.478,0,0,1-.882-1.458l.3-4.585a16.342,16.342,0,0,1,1.653-7.308l12.279-25.323,8.391,3.882-12.371,25.524a12.69,12.69,0,0,1-3.426,4.631c-.389.372-.821.787-1.315,1.289-1.067,1.086-2.172,2.215-2.957,3.024A1.472,1.472,0,0,1,1403.2,293.97Zm2.138-12.7a14.588,14.588,0,0,0-1.486,6.647l-.232,3.608c.684-.7,1.491-1.527,2.278-2.326.508-.518.954-.945,1.355-1.329a10.985,10.985,0,0,0,3.032-4.081l11.558-23.85-5.034-2.328Z",
    transform: "translate(-1401.708 -255.166)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2853",
    "data-name": "Group 2853",
    transform: "translate(0 45.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2521",
    "data-name": "Rectangle 2521",
    width: 2.911,
    height: 1.85,
    transform: "translate(0 2.604) rotate(-63.435)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2854",
    "data-name": "Group 2854",
    transform: "translate(2.261 36.789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    "data-name": "Path 4249",
    d: "M1409.359,305.311a4.936,4.936,0,0,0-5.048-2.358l-.364-1.813a6.749,6.749,0,0,1,7.017,3.25l-1.607.918.8-.459Z",
    transform: "translate(-1403.947 -301.01)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2855",
    "data-name": "Group 2855",
    transform: "translate(14.359 3.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4250",
    "data-name": "Path 4250",
    d: "M1431.982,257.62l-8.413-3.893,2.883-6.324,8.413,3.893Zm-5.967-4.8,5.056,2.339,1.349-2.957-5.056-2.339Z",
    transform: "translate(-1423.569 -247.403)",
    fill: "#93ddff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2856",
    "data-name": "Group 2856",
    transform: "translate(18.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    "data-name": "Path 4251",
    d: "M1435.824,248.725l-1.683-.767,1.489-3.265a.307.307,0,0,0-.146-.407l-2.3-1.065a.287.287,0,0,0-.221-.009.3.3,0,0,0-.167.157l-1.411,3.094-1.683-.768,1.411-3.093a2.143,2.143,0,0,1,2.849-1.06l2.3,1.066a2.161,2.161,0,0,1,1.053,2.853Z",
    transform: "translate(-1429.698 -241.343)",
    fill: "#93ddff"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.66c2c3b2485defadaeb164e240c5bf01.svg";
export { ForwardRef as ReactComponent };